// "Completa el look" del carrito lateral: carga las recomendaciones y añade con un toque
if (!customElements.get('cdc-carrito-recos')) {
  // El carrito se vuelve a pintar entero con cada cambio; así no se repite la petición
  const recomendacionesGuardadas = new Map();

  customElements.define(
    'cdc-carrito-recos',
    class CdcCarritoRecos extends HTMLElement {
      connectedCallback() {
        const clave = `${this.dataset.url}|${this.dataset.cesta}`;
        if (recomendacionesGuardadas.has(clave)) {
          this.pintar(recomendacionesGuardadas.get(clave));
        } else {
          fetch(this.dataset.url)
            .then((respuesta) => (respuesta.ok ? respuesta.text() : ''))
            .then((texto) => {
              const html = new DOMParser().parseFromString(texto, 'text/html').querySelector('.cdc-recos');
              const contenido = html ? html.innerHTML.trim() : '';
              recomendacionesGuardadas.set(clave, contenido);
              if (this.isConnected) this.pintar(contenido);
            })
            .catch(() => {});
        }

        this.addEventListener('click', (event) => {
          const boton = event.target.closest('[data-variante]');
          if (boton) this.anadir(boton);
        });
      }

      pintar(contenido) {
        this.innerHTML = contenido;
        this.hidden = !contenido;
      }

      async anadir(boton) {
        if (boton.getAttribute('aria-busy') === 'true') return;
        boton.setAttribute('aria-busy', 'true');

        const carrito = document.querySelector('cart-drawer');
        const datos = { items: [{ id: Number(boton.dataset.variante), quantity: 1 }] };
        if (carrito) {
          datos.sections = carrito.getSectionsToRender().map((seccion) => seccion.id);
          datos.sections_url = window.location.pathname;
        }

        try {
          const respuesta = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(datos),
          });
          const estado = await respuesta.json();

          if (!respuesta.ok || estado.status) {
            this.avisar(estado.description || 'No se ha podido añadir');
            boton.removeAttribute('aria-busy');
            return;
          }

          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cdc-carrito-recos', cartData: estado });
          }
          if (carrito && estado.sections) carrito.renderContents(estado);
          else window.location = window.routes?.cart_url || '/cart';
        } catch (error) {
          this.avisar('No se ha podido añadir');
          boton.removeAttribute('aria-busy');
        }
      }

      avisar(mensaje) {
        const aviso = this.querySelector('.cdc-recos__aviso');
        if (!aviso) return;
        aviso.textContent = mensaje;
        aviso.hidden = false;
        clearTimeout(this.temporizador);
        this.temporizador = setTimeout(() => {
          aviso.hidden = true;
        }, 4000);
      }
    }
  );
}
